import { render, staticRenderFns } from "./StoresEdit.vue?vue&type=template&id=6f215f1e&"
import script from "./StoresEdit.vue?vue&type=script&lang=js&"
export * from "./StoresEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports